import styled from 'styled-components'

const BlockTitleUi = styled.span`
  font-size: 14px;
  margin-right: auto;
  text-align: left;
`

export default BlockTitleUi
